import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CustomInput, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label } from "reactstrap";
import Select from "react-select";
import { map, filter, find } from "lodash";
import moment from "moment";
import { injectIntl } from "react-intl";
import CustomSelectInput from "../../components/common/CustomSelectInput";
import SingleDatePickerWrapper from "../../components/common/SingleDatePickerWrapper";
import Loader from "../../components/common/Loader";
import IntlMessages from "../../helpers/IntlMessages";
import { addRequestItem } from "../../redux/request/actions";
import { getServiceList } from "../../redux/service/actions";

class AddNewRequestModal extends Component {
  constructor(props) {
    super(props);

    this.props.getServiceList();

    this.state = {
      comment: "",
      dueDate: moment(),
      visibleServiceItems: [],
      customFields: [],
      selectedCustomFields: [],
      serviceType: { label: "Please Select a Service Type", value: 0 }
    };
  }

  componentDidMount() {
    this.setVisibleServiceItems();
  }

  setVisibleServiceItems = () => {
    const { allServiceItems } = this.props;
    this.setState({ visibleServiceItems: filter(allServiceItems, ["visible", "true"]) });
  };

  setServiceType = ({ label, value, type, key, customFields }) => {
    this.setState({ customFields: [], selectedCustomFields: [] });
    this.setState({ serviceType: { label, value, type, key }, customFields });
  };

  handleChange = e => {
    const { id } = e.target;
    const { selectedCustomFields } = this.state;
    const alreadyChecked = find(selectedCustomFields, { id });

    if (!alreadyChecked) {
      return this.setState(prevState => ({
        selectedCustomFields: [...prevState.selectedCustomFields, { id, value: "1" }]
      }));
    }
    const newArr = filter(selectedCustomFields, selectedCustomField => selectedCustomField.id !== id);
    return this.setState({
      selectedCustomFields: newArr
    });
  };

  resetState = () => {
    this.setState({
      comment: "",
      customFields: [],
      selectedCustomFields: [],
      serviceType: { label: "Please Select a Service Type", value: 0 },
      dueDate: moment()
    });
  };

  renderCustomFields = (customFields, selectedCustomFields) => (
    <>
      <Label className="mt-4">Custom Fields</Label>
      {map(customFields, ({ id, name }) => (
        <CustomInput
          key={id}
          type="checkbox"
          id={id}
          name={name}
          label={name}
          checked={find(selectedCustomFields, { id }) || false}
          onChange={this.handleChange}
        />
      ))}
    </>
  );

  onDateChange = date => {
    this.setState({ dueDate: date });
  };

  addNewItem = () => {
    const { comment, serviceType, selectedCustomFields, dueDate } = this.state;

    const {
      toggleModal,
      setShowError,
      booking: { hotel_id, bundle_id, fullName, id, user_id, tp_id },
      addRequestItem
    } = this.props;

    const newItem = {
      fullName,
      hotel_id,
      booking_id: id,
      bundle_id,
      status: "OPEN",
      custom_fields_values: selectedCustomFields,
      service_type: serviceType.type,
      service_id: serviceType.key,
      requester_id: user_id,
      due_at: dueDate.unix().toString(),
      tp_id,
      comments: [{ author_id: user_id, body: comment }]
    };

    if (newItem.service_id === undefined
      || ((newItem.service_id === 231 || newItem.service_id === "231"
        || newItem.service_id === 236 || newItem.service_id === "236")
        && newItem.custom_fields_values.length === 0)) {
      setShowError();
      return;
    }

    const response = addRequestItem(newItem);

    if (response.payload) {
      toggleModal();
      this.resetState();
    }
  };

  render() {
    const {
      modalOpen, toggleModal, showError, addRequestLoading, intl: { messages }
    } = this.props;

    const {
      comment, serviceType, visibleServiceItems, customFields, dueDate, selectedCustomFields
    } = this.state;

    return (
      <Modal isOpen={modalOpen} toggle={toggleModal} wrapClassName="modal-right" backdrop="static">
        <ModalHeader toggle={toggleModal}>
          <IntlMessages id="request.add-new-title" />
        </ModalHeader>

        <ModalBody>
          {addRequestLoading && <Loader />}

          {showError && (
            <div className="rounded alert alert-danger  fade show" role="alert">
              <IntlMessages id="request.error" />
            </div>
          )}

          <Label className="mt-4">
            <IntlMessages id="request.due" />
          </Label>

          <div className="dater">
            <SingleDatePickerWrapper
              small
              isOutsideRange={this.isOutsideRange}
              displayFormat={messages.birthdate_format}
              onDateChangeFunction={this.onDateChange}
              initialDate={dueDate}
              id="dueDate"
              showDefaultInputIcon
            />
          </div>

          <Label className="mt-4">
            <IntlMessages id="request.comment" />
          </Label>

          <Input
            type="textarea"
            defaultValue={comment}
            onChange={event => {
              this.setState({ comment: event.target.value });
            }}
          />

          <Label className="mt-4">
            <IntlMessages id="request.category" />
          </Label>

          <Select
            components={{ Input: CustomSelectInput }}
            className="react-select"
            classNamePrefix="react-select"
            name="form-field-name"
            options={
              visibleServiceItems &&
              map(visibleServiceItems, ({ id, name, type, custom_fields }) => {
                return { label: name, value: name, key: id, type, customFields: custom_fields };
              })
            }
            value={serviceType}
            onChange={service => this.setServiceType(service)}
          />

          <div>
            {customFields && customFields.length > 0 && this.renderCustomFields(customFields, selectedCustomFields)}
          </div>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" outline onClick={toggleModal}>
            <IntlMessages id="request.cancel" />
          </Button>

          <Button color="primary" onClick={() => this.addNewItem()}>
            <IntlMessages id="request.submit" />
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

AddNewRequestModal.propTypes = {
  serviceApp: PropTypes.shape({                  // details bir obje olmalı ve şu alanları içermeli:
    allServiceItems: PropTypes.object.isRequired,        // date alanı zorunlu ve string olmalı
  }),
  toggleModal: PropTypes.func.isRequired,
  addRequestItem: PropTypes.func.isRequired,
  getServiceList: PropTypes.func.isRequired,
  booking: PropTypes.object.isRequired,
  requestApp: PropTypes.shape({
    addRequestLoading: PropTypes.bool.isRequired
  }),
  intl: PropTypes.object.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  messages: PropTypes.string,
  setShowError: PropTypes.func.isRequired,
  showError: PropTypes.bool.isRequired
};

const mapStateToProps = ({ serviceApp, requestApp }) => {
  const { addRequestLoading } = requestApp;
  const { allServiceItems } = serviceApp;
  return { allServiceItems, addRequestLoading };
};

const mapActionsToProps = {
  addRequestItem,
  getServiceList,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(AddNewRequestModal)
);
